module.exports = function getResource(label, vars = []) {
    let resources = {
        viewAll: 'View all'
    };
    return resources[label];
};
